import dom from "../../dist/jsx-render/dom"
import { ComponentBase } from "./ComponentBase";
import { app } from "../Frame/App";

export type CheckboxComponentProps = {
    field: string;
    model: any;
    saveChanges?: boolean;
    label?: string;
    changeEvent?: (event: Event) => void;
    additionalCssClasses?: string;
    additionalElementClasses?: string;

    /** To not create a form group, set to false. */
    createFormGroup?: boolean;
}

export class CheckboxCompoment extends ComponentBase {
    constructor(props: CheckboxComponentProps) { super(props); }
    props: CheckboxComponentProps;

    guid: string = app.createGuid();

    element: HTMLElement = <div className={"form-check form-check-no-padding" + (this.props.additionalElementClasses ? " " + this.props.additionalElementClasses : "")}>
        <input type="checkbox"
            name={this.props.field}
            className="form-check-input"
            id={this.guid}
        />
        <label className="form-check-label" for={this.guid}>{this.props.label}</label>
    </div>;

    formGroup: HTMLElement = <div className={"form-group" + (this.props.additionalCssClasses ? " " + this.props.additionalCssClasses : "")}>
        {this.element}
    </div>;

    private handleChange = (event: Event) => {
        this.updateModelFromControl((event.target as HTMLInputElement).checked, this.props.field, this.props.model);

        // Call external event handler if present.
        if (this.props.changeEvent) {
            this.props.changeEvent(event);
        }
    }

    private updateModelFromControl(value: boolean, field: string, model: any) {
        model.setPropertyByPath(field, value);
    }

    render() {
        //var element = this.element;

        if (this.props.createFormGroup !== false) {
            this.element = this.formGroup;
        }

        if (!(this.props.saveChanges === false)) {
            this.element.querySelector("input").addEventListener('change', this.handleChange);
        }

        // set initial value, because checked="false" on the html input element
        // leads to a checked checkbox

        if (this.props.model) {
            (this.element.querySelector("input") as HTMLInputElement).checked = this.props.model.getPropertyByPath(this.props.field);
        }

        return this.element;
    }

    public disable = (removeValue: boolean = false) => {
        let input = (this.element.querySelector("input") as HTMLInputElement);
        if (removeValue) {
            this.updateModelFromControl(false, this.props.field, this.props.model);
            input.checked = false;
        }
        input.disabled = true;
    }

    public enable = () => {
        (this.element.querySelector("input") as HTMLInputElement).disabled = false;
    }

    public getValue(): boolean {
        return (this.element.querySelector("input") as HTMLInputElement).checked;
    }

    public setValue(value: boolean): void {
        (this.element.querySelector("input") as HTMLInputElement).checked = value;
        this.updateModelFromControl((this.element.querySelector("input") as HTMLInputElement).checked, this.props.field, this.props.model);
    }

    dispose() {
    }

    validate() {
    }
}